import { useAuth } from "react-oidc-context";

export function useAuthCheck() {
  const auth = useAuth();
  return { auth };
}